import { HttpProvider } from "../http/http.provider";
import { ServiceEndpointConstants } from "../ServiceUtil/consts/index";
import { Observable } from "rxjs";
import { share } from "rxjs/operators";
import { INewProfilePic } from "./authentication.interface";
import { createFormData } from "../util/utilities";

/**
 * Authentication Delegate - handles HTTP communication for authentication
 */
export class AuthenticationDelgate {
    constructor(private http: HttpProvider) {
    }

    public login(userName: string, password: string): Observable<any>
    {
        var request = {
            userName: userName,
            password: password
        };
        return this.http.post(ServiceEndpointConstants.endpoints.AUTH.LOGIN, request).pipe(share());
    }

    public resetPassword(obj: any): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.AUTH.RESET_REQUEST, obj).pipe(share());
    }

    public resetPasswordFromProfile(obj: any): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.AUTH.RESET_PASSWORD_PROFILE_REQUEST, obj).pipe(share());
    }

    public resetPasswordReq(obj: any): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.AUTH.RESET_PASSWORD_REQUEST, obj).pipe(share());
    }

    public logout(): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.AUTH.LOGOUT).pipe(share());
    }

    public updateProfilePic(documents: INewProfilePic): Observable<any>
    {
        const formdata = createFormData(documents);

        return this.http.post(ServiceEndpointConstants.endpoints.AUTH.UPDATE_PROFILE_PIC, formdata).pipe(share());
    }
}